import { apiClient } from '../../api/client';
import type { components } from '../../api/generated/schema';
import type { NewComment } from '../../domain/comments';
import { mapped } from '../errors';
import type { CommentsRepository } from './CommentsRepository';
import { toComment, toNewComment } from './mapping';

type S = components['schemas'];

const listingComments = (listingId: string) =>
  `/api/v1/listings/${encodeURIComponent(listingId)}/comments/`;

export const httpCommentsRepository: CommentsRepository = {
  list: (listingId: string) =>
    mapped(async () => (await apiClient.commentsList(listingId)).map(toComment)),
  post: (listingId: string, comment: NewComment) =>
    mapped(async () =>
      toComment(
        await apiClient.send<S['Comment']>(
          'POST',
          listingComments(listingId),
          toNewComment(comment),
        ),
      ),
    ),
  delete: (commentId: string) =>
    mapped(async () => {
      await apiClient.send('DELETE', `/api/v1/comments/${encodeURIComponent(commentId)}/`);
    }),
};
